import { render, staticRenderFns } from "./AvatarComponent.vue?vue&type=template&id=6431451f&scoped=true&"
import script from "./AvatarComponent.vue?vue&type=script&lang=js&"
export * from "./AvatarComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6431451f",
  null
  
)

export default component.exports